"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function ApparelCategoriesConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i}>
            <Card className="h-48 animate-pulse bg-muted/30 border-border rounded-2xl" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-sm text-destructive font-default">
          Kategorien konnten nicht geladen werden.
        </p>
        <Button onClick={refetch} variant="outline" className="rounded-lg border-primary text-primary hover:bg-primary hover:text-primary-foreground">
          Erneut versuchen
        </Button>
      </div>;
  }
  if (terms.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground font-default">Keine Kategorien gefunden.</p>
      </div>;
  }
  return <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
      {terms.map((term, i) => <div key={term.id} data-index={i} className="h-full">
          <Link to={term.link || "/ShopPage"} className="block h-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-2xl">
            <Card className="group flex h-full cursor-pointer flex-col items-center justify-center border-border bg-card p-6 transition-all duration-500 hover:shadow-lg hover:bg-accent/50 rounded-2xl">
              {term.image_url ? <div className="mb-4 flex size-20 items-center justify-center overflow-hidden rounded-2xl bg-muted md:size-24">
                  <img src={term.image_url} alt={term.name} className="size-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                </div> : <div className="mb-4 flex size-20 items-center justify-center rounded-2xl bg-muted md:size-24">
                  <span className="text-2xl font-default font-bold text-muted-foreground md:text-3xl">
                    {term.name.charAt(0)}
                  </span>
                </div>}
              <h3 className="font-default text-center text-base font-bold text-foreground md:text-lg tracking-tight">
                {term.name}
              </h3>
            </Card>
          </Link>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 8,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function ApparelCategories() {
  return <section data-section-id="223235" id="unsere-kategorien" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-10 text-center md:mb-16">
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tight text-foreground md:text-5xl">
            Hier kannst Du stöbern
          </h2>
          <p className="mx-auto max-w-2xl text-muted-foreground font-default text-lg">
            Entdecke unsere liebevoll ausgewählten Second-Hand Schätze und handgemachten Geschenkartikel.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <ApparelCategoriesConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}